<pcs-login-info  class="col-8" [appInfo]="appInfo$ | async"></pcs-login-info>
<pcs-login-form (submitted)="onSubmit($event)" (changed)="onChange()" [appInfo]="appInfo$ | async" [authError]="authError$ | async" class="col-4"></pcs-login-form>
